"use client";
import { Card, CardFooter, CardHeader } from "@dxp-feed/ui/Card";

import { Text } from "@dxp-feed/ui/Text";
import Link from "@/components/Link";
import FavouriteRecipe from "../_components/FavouriteRecipe";
import {
  useAppDispatch,
  useAppSelector,
  useCallback,
  useState,
  useRef,
} from "@/utils/hooks/reactUseCustomHooks";
import {
  CheckIfRecordIsPreferred,
  minToHourConverter,
} from "@/helpers/useCommonFunctions";
import {
  analyticsAddToFavouriteEventAfterSearch,
  analyticsAddToFavouriteEventBeforeSearch,
  analyticsClickEventAfterSearch,
  analyticsClickEventBeforeSearch,
} from "@/services/algolia/analytics";
import { algoliaConfig } from "@/services/algolia/config";
import { Box } from "@dxp-feed/ui/Box";
import LoginModal from "../UI/Modals/LoginModal";
import { addDataLayerOfRecipeToList } from "@/helpers/dataLayer";
import useFavorites from "../common/commonRecipeFunctions/useFavourites";
import ImageWrapper from "@/components/ImageWrapper";
import { Recipe_list_name, RecipeImage } from "@/utils/constant";
import { decodeHtml } from "../common/commonRecipeFunctions";
import { useEffect } from "react";
import useNetwork from "../common/commonRecipeFunctions/useNetwork";

import RecipeCardMealPlanLoginPopup from "./RecipeCardMealPlanLoginPopup";
import RecipeCardMealPlanPopup from "./RecipeCardMealPlanPopup";
import { setToastMessage } from "@/utils/redux/recipes/toastMessageSlice";

import { setDataLayerSlice } from "@/utils/redux/dataLayerSlice";
import { getCookie } from "cookies-next";
interface RecipeCardProps {
  item: any;
  list_name?: string;
  searchQuery?: string;
  isSearchPage?: boolean;
  index?: number;
  hasAddToFavRun?: any;
}

export const RecipeCard = ({
  index,
  item,
  list_name,
  searchQuery = "",
  isSearchPage = false,
  hasAddToFavRun = false,
}: RecipeCardProps) => {
  const isOnline = useNetwork();
  const dispatch = useAppDispatch();

  const { aemMealPlanData: aemMealPlanData } = useAppSelector(
    (state) => state.AemModalSlice
  );

  // const { favouritesRecipes }: any = useAppSelector(
  //   (state) => state.favouritesRecipeSlice
  // );

  const { uid: Uid } = useAppSelector((state) => state.gigyaslice);

  const userSession = useAppSelector((state) => state.gigyaslice);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [recipeId, setRecipeId] = useState<any>(null);

  const [isRecipeCardLoginModalOpen, setIsRecipeCardLoginModalOpen] =
    useState(false);
  const [isRecipeCardMealPlanModalOpen, setIsRecipeCardMealPlanModalOpen] =
    useState(false);
  const [openFavModal, setOpenFavModal] = useState<any>(false);
  const [favItem, setFavItem] = useState<any>(item);
  const { favourite } = useAppSelector((state) => state.RecipeToList);

  const [openMealPlanModal, setOpenMealPlanModal] = useState<any>(false);
  const [mealPlanItem, setMealPlanItem] = useState<any>([]);

  const {
    addToFavorite,
    afterLoginAddToFav,
    afterLoginAddToMealPlan,
    isModalOpen,
    setIsModalOpen,
    isFavourite,
    openFavourite,
    favLoading,
  }: any = useFavorites();
  const { messages: MESSAGE } = useAppSelector((state) => state.messageSlice);
  const userId = userSession?.uid ?? undefined;
  const [checkFavourite, setCheckFavourite] = useState(false);
  // const { favourite }: any = useAppSelector(
  //   (state) => state.favouritesRecipeSlice
  // );

  const { aemRecipeModelData: aemModalData } = useAppSelector(
    (state) => state.AemModalSlice
  );

  useEffect(() => {
    if (favourite?.recipes?.length) {
      setCheckFavourite(
        favourite?.recipes?.some((fav: any) => fav.recipe_id === item.objectID)
      );
    } else {
      setCheckFavourite(false);
    }
  }, [favourite?.recipes]);

  useEffect(() => {
    const checkAndRun = async () => {
      const rawValue = await getCookie("susfvd");
 
      if (!hasAddToFavRun.current && rawValue && Uid && favourite?.id) {
        hasAddToFavRun.current = true;
 
        void afterLoginAddToFav({
          hasRunRef: hasAddToFavRun,
          setOpenFavModal,
          setFavItem,
        });
      }
    };
 
    void checkAndRun();
  }, [Uid, favourite?.id]);

  const loginStates = useCallback(
    async (item: any) => {
      setMealPlanItem(item);
      setOpenMealPlanModal(true);
    },
    [setOpenMealPlanModal, setMealPlanItem] // add other dependencies if needed
  );
  useEffect(() => {
    if (Uid && typeof loginStates === "function") {
      void afterLoginAddToMealPlan({
        loginStates,
      });
    }
  }, [Uid, loginStates]);

  const recipeClickHandler = () => {
    // algolia click event
    dispatch(setDataLayerSlice(list_name));

    if (searchQuery?.length) {
      analyticsClickEventAfterSearch({
        kind: "recipes",
        index: algoliaConfig.indexNames.recipes,
        objectIDs: [String(item.objectID)],
        userToken: userId,
        positions: [item.__position!],
        queryID: String(item.__queryID),
      });
    } else {
      analyticsClickEventBeforeSearch({
        kind: "recipes",
        index: algoliaConfig.indexNames.recipes,
        objectIDs: [String(item.objectID)],
        userToken: userId,
      });
    }
  };

  const handleAddToFavouriteAlgoliaEvent = () => {
    if (searchQuery?.length) {
      analyticsAddToFavouriteEventAfterSearch({
        kind: "recipes",
        index: algoliaConfig.indexNames.recipes,
        objectIDs: [String(item.objectID)],
        userToken: userId,
        queryID: String(item.__queryID),
      });
    } else {
      analyticsAddToFavouriteEventBeforeSearch({
        kind: "recipes",
        index: algoliaConfig.indexNames.recipes,
        objectIDs: [String(item.objectID)],
        userToken: userId,
      });
    }
  };

  const handleAddToMealPlan = (event: any, item: any) => {
    event.preventDefault();
    event.stopPropagation();
    if (!isOnline) {
      dispatch(
        setToastMessage({
          message: `${MESSAGE.ERROR_MESSAGE.OFFLINE_ERROR}`,
          status: "other",
          color: "error",
        })
      );
    } else {
      if (!userId) {
        setIsRecipeCardLoginModalOpen(true);
        setRecipeId(item?.objectID);
      } else {
        setIsRecipeCardMealPlanModalOpen(true);
      }
    }
  };

  const closeLoginModal = () => setIsLoginModalOpen(false);
  const mealPlanButtonRef = useRef<HTMLSpanElement | null>(null);

  return (
    <>
      <Link
        href={item?.pageSlug ? `/recipes/${item?.pageSlug}` : `/not-found`}
        passHref
        onClick={recipeClickHandler}
        className="relative pb-10 bg-brandWhite shadow-md rounded-lg overflow-hidden block h-full"
        aria-label={`${decodeHtml(item?.title || "")} ${
          item?.cooking?.totalTime
            ? minToHourConverter(item?.cooking?.totalTime)
            : ""
        }`}
      >
        <Card className="shadow-none">
          <Box
            as="div"
            className="relative bg-grey300 min-h-[150px] overflow-hidden pt-[57%] md:pt-[58%] xl:pt-[52%] "
          >
            <Box className="imgTabBorder">
              <ImageWrapper
                // src={item?.featuredImage}
                src={`${RecipeImage + item?.featuredImage || item?.featuredImage}`}
                loading="lazy"
                alt={item?.title ?? "Recipe Image"}
                fill
                className="absolute top-0 left-0 object-cover"
              />
            </Box>
            <Box
              as="div"
              className={`absolute bottom-[60px] right-[15px] flex gap-2 flex-col ${isSearchPage ? "z-[2]" : ""}`}
            >
              <Box className="flex justify-end" 
              id={index === 0 ? `recipe_favorite_${index}` : undefined}
              >
                <Box
                  as="span"
                  tabIndex={0}
                  ref={mealPlanButtonRef}
                  onClick={(event: any) => {
                    handleAddToMealPlan(event, item);
                  }}
                  onKeyDown={(event: any) => {
                    if (event.key === "Enter" || event.key === " ") {
                      handleAddToMealPlan(event, item);
                      event.currentTarget.click();
                    }
                  }}
                  className={`tab rounded-full cursor-pointer bg-brandWhite [&>span]:text-brandSecondary`}
                >
                  <Box
                  as="div"
                  className="relative overflow-hidden"
                  // id={index === 0 ? `recipe_favorite_${index}` : undefined}
                >
                  <Text
                    as="span"
                    className={`text-[18px] h-[40px] w-[40px] group flex justify-end items-center text-brandBlack rounded-full border border-brandSecondary relative transition-all duration-500 hover:border-brandSecondary z-[9] hover:w-[172px]`}
                  >
                    <Text
                      as="span"
                      className={`text-left absolute left-0 pr-[20px] w-auto max-w-[210px] whitespace-nowrap opacity-0 group-hover:opacity-100 transform translate-x-[100%] group-hover:translate-x-0 transition-all duration-500 ease-in-out delay-150 pl-3 text-[14px] z-10 text-brandSecondary`}
                    >{aemModalData?.addToMealPlan}
                    </Text>
                    <Text
                      as="span"
                      className={`flex justify-end items-center rounded-full bg-brandWhite p-[10px] icon-add-calender text-brandSecondary transition-all duration-500 z-20`}
                    ></Text>
                  </Text>
                </Box> 
                </Box>
              </Box>

              </Box>
              <Box
              as="div"
              className={`absolute bottom-[12px] right-[15px] flex gap-2 flex-col ${isSearchPage ? "z-[2]" : ""}`}
              id={index === 0 ? `recipe_favorite_Icon_${index}` : undefined}
            >

              <Box
                tabIndex="0"
                as="div"
                role="button"
                className={`tab rounded-full cursor-pointer bg-brandWhite ${checkFavourite ? " [&>span]:text-brandSecondary" : ""}`}
                aria-label={`${checkFavourite ? (aemModalData?.removeFromFavourite ?? "Remove from favorite") : (aemModalData?.addToFavourite ?? "Add from favorite")}`}
                onClick={(event: any) => {
                  event.preventDefault();
                  event.stopPropagation();
                  openFavourite();
                  const isAddingToFavorites = favourite && !checkFavourite;
                  if (isAddingToFavorites && Uid) {
                    addDataLayerOfRecipeToList({
                      event: "add_to_favorite",
                      recipe_name: item?.title,
                      list_name: list_name,
                      recipe_list_name: Recipe_list_name,
                      page_title: document.title,
                      item: "Recipe",
                    });
                  }
                  if (!checkFavourite && Uid)
                    handleAddToFavouriteAlgoliaEvent();
                  if (favourite && Uid) addToFavorite(item, checkFavourite);
                  setIsLoginModalOpen(true);
                  setRecipeId(item?.objectID);
                  // if (Uid && isOnline) setCheckFavourite((prev: any) => !prev);
                }}
                onKeyDown={(event: any) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    event.currentTarget.click();
                  }
                }}
              >
                <Box
                  as="div"
                  className="relative overflow-hidden"
                  // id={index === 0 ? `recipe_favorite_${index}` : undefined}
                >
                  <Text
                    as="span"
                    className={`text-[18px] h-[40px] w-[40px] group flex justify-end items-center text-brandBlack rounded-full border border-brandSecondary relative transition-all duration-500 hover:border-brandSecondary z-[9]
                      ${checkFavourite ? "hover:w-[212px]" : "hover:w-[164px]"}`}
                  >
                    <Text
                      as="span"
                      className={`text-left absolute left-0 pr-[20px] w-auto max-w-[210px] whitespace-nowrap opacity-0 group-hover:opacity-100 transform translate-x-[100%] group-hover:translate-x-0 transition-all duration-500 ease-in-out delay-150 pl-3 text-[14px] z-10 text-brandSecondary`}
                    >
                      {checkFavourite
                        ? aemModalData?.removeFromFavourite
                        : aemModalData?.addToFavourite}
                    </Text>
                    <Text
                      as="span"
                      className={`flex justify-end items-center rounded-full bg-brandWhite p-[10px] ${checkFavourite ? "icon-filled-heart text-brandSecondary" : "icon-heart text-brandSecondary"} transition-all duration-500 z-20`}
                    ></Text>
                  </Text>
                </Box>
              </Box>

              </Box>
          </Box>
          <CardHeader className="border-none">
            <Text as="span" className="text-base font-bold">
              {decodeHtml(item?.title || "")}
            </Text>
          </CardHeader>

          <CardFooter className="!pt-0 !border-t-0 absolute bottom-0">
            {item?.cooking?.totalTime ? (
              <Text as="ul" className="flex gap-[18px]">
                <Text as="li" className="flex items-center gap-1">
                  <Text
                    as="span"
                    className="demo-icon icon-clock w-[27px] h-[27px] text-[22px] flex items-center justify-center "
                  ></Text>
                  {minToHourConverter(item?.cooking?.totalTime)}
                </Text>
              </Text>
            ) : (
              ""
            )}
          </CardFooter>
        </Card>
      </Link>
      {!userId ? (
        <>
          <LoginModal
            isModalOpen={isLoginModalOpen}
            closeModal={closeLoginModal}
            label={MESSAGE.LOGIN_MESSAGE}
            recipeId={recipeId}
          />
          <RecipeCardMealPlanLoginPopup
            isRecipeCardLoginModalOpen={isRecipeCardLoginModalOpen}
            closeLoginModal={() => setIsRecipeCardLoginModalOpen(false)}
            recipeId={recipeId}
          />
        </>
      ) : (
        <>
          {(isFavourite || openFavModal) && (
            <FavouriteRecipe
              recipeData={openFavModal ? favItem : item}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              list_name={list_name ?? ""}
              FavouritesData={favourite?.recipes}
              favLoading={favLoading}
            />
          )}

          {(isRecipeCardMealPlanModalOpen ||
            (openMealPlanModal &&
              item?.objectID === mealPlanItem?.objectID)) && (
            <RecipeCardMealPlanPopup
              isRecipeCardMealPlanModalOpen={
                isRecipeCardMealPlanModalOpen || openMealPlanModal
              }
              closeRecipeCardMealPlanModal={() => {
                setIsRecipeCardMealPlanModalOpen(false);
                setOpenMealPlanModal(false);
                mealPlanButtonRef.current?.focus(); // 👈 Restore focus here
              }}
              recipeData={openMealPlanModal ? mealPlanItem : (item ?? [])}
            />
          )}
        </>
      )}
    </>
  );
};
